import { Component, OnInit } from '@angular/core';
// ----------------INTERFACE----------------------------------
import { IFilterConfig } from 'src/app/modules/core/interfaces/filter-config';
import { ICheckFilter } from '../../../core/interfaces/check-filter';
import { IOutputFilter } from '../../../core/interfaces/output-filter';
import { ILayoutConfig } from '../../../layout/interfaces/layout-config';
import { ILoopByOperatorResponse, ITotalLoopEmbeddedDetail } from '../../interfaces/report-loop-by-operator';
// import { IMachineContext } from 'projects/common/src/app/interfaces/machine-context';
// -------------------SERVICES---------------------------------
import { CacheService, MiningToastService } from 'projects/common/src/app/services';
import { LanguageService } from '../../../../../../projects/common/src/app/services/parameters/language/language.service';
import { FilterHandlerService } from '../../../core/services/filter/filter-handler.service';
import { LayoutConfigService } from '../../../layout/services/layout-config.service';
import { ReportLoopEmbeddedByMachineTruckService } from '../../services/report-loop-embedded-by-machine-truck.service';
//------------------------------------------------------------
import { Logger } from 'projects/common/src/app/classes';
import { ExcelExportService } from 'projects/common/src/app/services/utils/excel-export.service';
import { DateTimePresentationPipe } from 'src/app/modules/core/pipes/date-time-presentation.pipe';
import { GoogleAnalyticsService } from 'src/app/modules/core/services/google/google-analytics.service';
import { excelExportDateFormat } from '../../../../../../projects/common/src/app/services/utils/util.service';

@Component({
  selector: 'app-loop-embedded-by-machine-truck',
  templateUrl: './loop-embedded-by-machine-truck.component.html',
  styleUrls: ['./loop-embedded-by-machine-truck.component.scss'],
})
export class LoopEmbeddedByMachineTruckComponent extends Logger implements OnInit {
  public showFilter: ICheckFilter;
  public selectedFilters: IOutputFilter;
  public message: string = null;
  public reportResult: ILoopByOperatorResponse;
  public canDownload = false;
  public hasData = false;
  public isLhd: boolean;
  // public isTruck: boolean;
  public systemError: string;
  public filterConfig: IFilterConfig;
  public tableData: ITotalLoopEmbeddedDetail[];
  public btnSpinner: boolean;
  public disabledExcelBtn: boolean;

  constructor(
    protected layoutConfigService: LayoutConfigService,
    protected languageService: LanguageService,
    protected loopEmbeddedByMachineTruckService: ReportLoopEmbeddedByMachineTruckService,
    protected filterHandlerService: FilterHandlerService,
    protected cacheService: CacheService,
    protected datePipePresentation: DateTimePresentationPipe,
    private googleAnalyticsService: GoogleAnalyticsService,
    protected _excelExportService: ExcelExportService,
    protected _toastService: MiningToastService,
  ) {
    super();
    this.declareFilters();
    this.tableData = [];
    this.disabledExcelBtn = false;
  }

  /**
   * On init component
   */
  public ngOnInit(): void {
    this.isLhd = true;
    this.initLayoutTitle();
  }
  /**
   * Function to declare filter to show
   */
  protected declareFilters(): void {
    this.filterConfig = {
      dates: { required: true, options: { monthsRange: 24, minMonth: 24 } },
      shift: { required: true },
      cleanButton: true,
    };
  }

  /**
   * Function to select icon image, title & subtitle
   */
  protected initLayoutTitle(): void {
    const subtitle = 'report-embedded-loops-by-machine-truck';
    const config: ILayoutConfig = {
      title: 'reports',
      subtitle,
      imageKey: 'report',
      imageType: 'section',
    };
    this.layoutConfigService.setConfig(config);
  }

  /**
   * Function to get report data from received filters
   *
   * @param filters Filters selected to get data
   */
  public getReportEmbeddedByMachineTruck(selectedFilters: IOutputFilter): void {
    this.filterConfig.isLoading = true;
    if (selectedFilters) {
      this.selectedFilters = selectedFilters;
      this.loopEmbeddedByMachineTruckService.getLoopEmbeddedByMachineTruckResult(this.selectedFilters).then(
        (response) => {
          this.reportResult = response;

          const thereIsLoopOperatorResult = !!this.reportResult.loopsEmbeddedDetail && this.reportResult.loopsEmbeddedDetail.length > 0;
          const thereIsLoopByMachineTable = !!this.reportResult.totalLoopsByMachine && this.reportResult.totalLoopsByMachine.length > 0;
          const thereIsLoopByShiftCards = !!this.reportResult.totalLoopsByShift && this.reportResult.totalLoopsByShift.length > 0;

          if (thereIsLoopOperatorResult && thereIsLoopByMachineTable && thereIsLoopByShiftCards) {
            for (const item of this.reportResult.loopsEmbeddedDetail) {
              this.tableData.push({
                machineName: item.machineName,
                tagId: item.tagId,
                shiftId: item.shiftId,
                shiftName: `${item.shiftName} ${this.datePipePresentation.transform(item.shiftDate)}`,
                startdateAt: item.startedAt,
                finalDateAt: item.finishedAt,
                duration: item.duration,
                detail: 'Ver Detalle',
              });
            }
            this.canDownload = true;
            this.hasData = true;
            this.message = null;
          } else {
            this.hasData = false;
            this.canDownload = false;
            this.message = this.languageService.message('m034');
          }
          this.systemError = '';
          this.filterConfig.isLoading = false;
        },
        ({ name, message }) => {
          this.error(message);
          this.systemError = name === 'TimeoutError' ? 'm014' : 'm017';
          this.hasData = false;
          this.canDownload = false;
          this.filterConfig.isLoading = false;
        },
      );
    }
    const filters = {
      reports: 'loop-embedded-bt-machine-truck',
    };
    this.googleAnalyticsService.sendCustomEvent('filter', filters);
  }

  /**
   * Function to download report in excel format
   */
  public async downloadExcel(): Promise<void> {
    const selectRangeDate = {
      startDate: excelExportDateFormat(this.selectedFilters.startDate),
      endDate: excelExportDateFormat(this.selectedFilters.endDate),
    };
    this.btnSpinner = true;
    this.disabledExcelBtn = true;
    this.loopEmbeddedByMachineTruckService.getLoopEmbeddedByMachineTruckExcel(this.selectedFilters).subscribe({
      next: (response) => {
        this._excelExportService.exportAsExcel(response, 'report-embedded-loops-by-machine-truck', selectRangeDate, null, false);
        this.btnSpinner = true;
        this.disabledExcelBtn = true;
        this._excelExportService.messageToastSuccess();
      },
      error: () => {
        this.btnSpinner = false;
        this.disabledExcelBtn = false;
        this._excelExportService.messageToastError();
      },
    });
  }
}
